import React from "react";
import { client1, formImg } from "..";

function AbstractTestimonial() {
  return (
    <section className="absTestimonialSection">
      <div className="container">
        <div className="row">
          <div className="col-md-8 mx-auto">
            <div className="abstestiWrap">
              <img src={client1} alt="Abstract" className="img-fluid" />
              <h5>
                “The Vodote team helped us transition from legacy systems to a hardened infrastructure. Their attention to risk, user safety, and compliance made a measurable impact on our operations.”
              </h5>
              <div className="profileImgWrap">
                <img src={formImg} alt="Abstract" className="img-fluid" />
              </div>
              <h6>Lina Patel</h6>
              <span>CISO</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AbstractTestimonial;
